import { mapActions } from 'vuex';
import Events from '_utils/events';
import SampleService from '_services/rest/modules/sample';

export default {
  name: 'sample-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      SampleService.deleteSample(this.selectedObject)
        .then(() => {
          this.close();
          this.$router.push('/admin/amostra/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Amostra deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
